import { formatInTimeZone } from "date-fns-tz";

const TZ = "America/New_York";

function toDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d) ? null : d;
}

function fmt(value, pattern) {
  const d = toDate(value);
  return d ? formatInTimeZone(d, TZ, pattern) : "";
}

// "Apr 22, 3:45 PM EDT"
export function fmtEST(value) {
  return fmt(value, "MMM d, h:mm a zzz");
}

// "Apr 22, 2026, 3:45 PM EDT"
export function fmtDateTimeEST(value) {
  return fmt(value, "MMM d, yyyy, h:mm a zzz");
}

// "Apr 22, 2026"
export function fmtDateEST(value) {
  return fmt(value, "MMM d, yyyy");
}

// "3:45 PM EDT"
export function fmtTimeEST(value) {
  return fmt(value, "h:mm a zzz");
}

// "3:45:22 PM EDT"
export function fmtTimeSecondsEST(value) {
  return fmt(value, "h:mm:ss a zzz");
}

// For live clock: "04/22  Wednesday  15:45" — same format as DashboardLayout used
export function fmtClockEST(date) {
  return fmt(date || new Date(), "MM/dd  EEEE  HH:mm");
}
